export const calendarUrl = 'ellythebot@gmail.com'
export const apiKey = 'AIzaSyDxBq54kdBWtzCqQS8vYLcK2mgPDNYJUT4'
// export const PORT = 'http://localhost:3001'
export const PORT = process.env.NODE_ENV === 'development' ? 'https://myreadyteacher.com' : 'https://myreadyteacher.com'
// export const googleurl = "78408208180-ajvhr96aieevvng4fh627vr6ajuhd77t.apps.googleusercontent.com"
export const stripe_public_key = "pk_test_dgrzNeAl7wpPZjgcchLfbh4b"

//this must be the same as the backend for GOOGLE_CLIENT_LOGIN_ID
export const googleurl = "370589153683-qo8r3uhm7shetk4olp3jg99o5s4los7p.apps.googleusercontent.com"

export const GOOGLE_DRIVE_CLIENT_ID = "1083822426953-te4l8stkbc4rghbn0547j0oc85d4aa4a.apps.googleusercontent.com"
export const GOOGLE_DRIVE_DEVELOPER_KEY = "AIzaSyA70yVmMb47V22vS-YLKh9t2e3U8Muqk1o"
